import { Tabs } from 'antd'
import moment from 'moment'
import * as React from 'react'

const { TabPane } = Tabs

interface MonthSwitcherProps {
    value: moment.Moment
    onChange: (value: moment.Moment) => void
}

export const MonthSwitcher: React.FC<MonthSwitcherProps> = (props) => {
    let panels = moment.months().map((month: string, index: number) => <TabPane tab={month} key={index} />)

    const onChange = (month: number) => {
        let year = props.value.year()
        let date = moment([year, month])
        props.onChange(date)
    }

    return (
        <Tabs
            centered={true}
            activeKey={props.value.month().toString()}
            onChange={e => onChange(+e)}>
            {panels}
        </Tabs>
    )
}

MonthSwitcher.defaultProps = {
    value: moment()
}